import styled from '@emotion/styled';
import { Box } from '@mui/material';
import React from 'react';

import WsColors from '../../WsColors';
import { WsDataGridPagination } from '../WsDataGridPagination';
import { WsTypography, WsTypoVariants } from '../WsTypography';

const StyledPaginationBox = styled(Box)(() => ({
  display: 'flex',
  height: 60,
  backgroundColor: WsColors.White,
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const WsPaginationBar = ({
  totalRecords,
  pageSize,
  page,
  onPageChange,
  onPageSizeChange,
}: {
  totalRecords: number;
  pageSize: number;
  page: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}) => (
  <StyledPaginationBox>
    <Box display="flex" gap={1}>
      <WsTypography variant={WsTypoVariants.SUB_TITLE}>Total Count:</WsTypography>
      <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
        {totalRecords}
      </WsTypography>
    </Box>
    {totalRecords > 10 && (
      <WsDataGridPagination
        count={Math.ceil(totalRecords / pageSize)}
        page={page + 1}
        onPageChange={(_, page: number) => onPageChange?.(page - 1)}
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
      />
    )}
  </StyledPaginationBox>
);

export default WsPaginationBar;
